import {Autosize} from './src/autosize.directive';

export * from './src/autosize.directive';

export default {
  directives: [Autosize]
}



// WEBPACK FOOTER //
// ./~/angular2-autosize/angular2-autosize.ts